import { i18n } from '@/i18n'
import store from '@/store'

export default (params) => {
  const hasModulePermisosGruposTraspasoNEOs = store.getters['auth/hasModulePermisosGruposTraspasoNEOs']
  const menu = [
    {
      icon: 'config',
      name: i18n.t('app.groups'),
      path: 'configurations/groups',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'configurations/groups/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('app.users_link'),
          path: 'configurations/groups/users',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('app.companies_link'),
          path: 'configurations/groups/companies',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('configurations.status_link'),
          path: 'configurations/groups/status',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('app.groups_rules'),
          path: 'configurations/groups/rules',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
      ]
    }
  ]

  const submenuGroups = {
    name: i18n.t('app.groups_groups'),
    path: 'configurations/groups/groups',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const submenuHistorical = {
    name: i18n.t('app.historical'),
    path: 'configurations/groups/historical',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  if (hasModulePermisosGruposTraspasoNEOs) {
    menu[0].sc.push(submenuGroups)
  }
  menu[0].sc.push(submenuHistorical)
  return menu
}
